<script>
  // A labeled filter dropdown (searchable Combobox — native <select> popups can't be
  // styled and can't search/paginate). Self-navigates via a URL `param` (like
  // SearchInput / FilterTabs), or calls `onchange(value)` if you need a custom handler.
  // The Sort control is just `<FilterSelect label="Sort" param="sort" placeholder={null} …>`.
  // For large server-backed lists pass `source` (an AdminSite::OptionsProp source key)
  // instead of `options` — the list is then searched + paginated server-side.
  import { router, page } from '@inertiajs/svelte'
  import FilterField from './filter_field.svelte'
  import Combobox from './ui/combobox.svelte'

  let {
    label = null,
    id = undefined,
    param = null,
    value = '',
    options = [],
    source = null,
    sourceParams = {},
    placeholder = 'All',
    width = 'w-48',
    onchange = null
  } = $props()

  const navigate = (v) => {
    const url = new URL($page.url, 'http://placeholder')
    if (v) url.searchParams.set(param, v)
    else url.searchParams.delete(param)
    url.searchParams.delete('page')
    router.get(`${url.pathname}${url.search}`, {}, { preserveState: true, preserveScroll: true, replace: true })
  }

  const handle = (v) => {
    if (onchange) onchange(v)
    else if (param) navigate(v)
  }
</script>

<FilterField {label} for={id}>
  <!-- Fixed width: the trigger otherwise stretches to its widest option label (e.g.
       long place names), blowing the filter bar out. The dropdown still shows full
       option text when open. placeholder={null} (the Sort control) means the filter
       always has a value — no clear row. -->
  <Combobox
    {id}
    {value}
    {options}
    {source}
    {sourceParams}
    size="sm"
    {width}
    placeholder={placeholder ?? 'Select…'}
    clearable={placeholder !== null}
    ariaLabel={label}
    onchange={handle}
  />
</FilterField>
